import { dateToTimestamp, Timestamp, timestampToDate } from '../../domain'

export interface BreakdownBasedOn {
  modelPortfolios?: BreakdownBasedOnModelPortfolio[]
  instruments?: BreakdownBasedOnInstrument[]
  investorAccounts?: BreakdownBasedOnInvestorAccount[]
}

export interface BreakdownBasedOnInstrument {
  validAt: Timestamp
  isin?: string
  idType?: string
  idValue?: string
}

export interface BreakdownBasedOnModelPortfolio {
  validAt: Timestamp
  id: string
}

export interface BreakdownBasedOnInvestorAccount {
  validAt: Timestamp
  id: string
}

/**
 * getMinMax returns the minimum and maximum timestamp of a basedOn. It removes
 * any duplicates such that if there is only one data the timestamp array
 * outputted may be only 1 long. If there are no entries in the basedOn, the output may be empty.
 */
export const getMinMaxTimestamp = (basedOn: BreakdownBasedOn): Timestamp[] => {
  const dates = [
    ...(basedOn.instruments?.map(({ validAt }) => validAt) ?? []),
    ...(basedOn.modelPortfolios?.map(({ validAt }) => validAt) ?? []),
    ...(basedOn.investorAccounts?.map(({ validAt }) => validAt) ?? []),
  ]
    .map(timestampToDate)
    .filter((date, i, self) => self.findIndex((d) => d.getTime() === date.getTime()) === i)
    .sort((a, b) => a.getTime() - b.getTime())
    .map(dateToTimestamp)
  switch (dates.length) {
    case 0:
      return []
    case 1:
      return dates
    case 2:
      return dates
    default:
      return [dates[0], dates[dates.length - 1]]
  }
}
